<template>
  <div class="station" v-loading="loading">

    <page-header :title="station.name" icon="share-alt">
      <div slot="sub-title">
        {{ station.organization.name }}
      </div>
      <div slot="controls">
        <icon-button icon="qrcode" v-if="$root.isSystem" size="30" style="margin-right: 40px;" fa @click="showQRDialog = true" />
        <div class="status-button" :class="[getStatus.class]" @click="setStatus">
          <i :class="getStatus.icon"></i>
          <p>{{ getStatus.name }}</p>
        </div>
        <div class="control-block-item" style="margin-left: auto;">
          <i :class="[isPublic.icon]"></i>
          <p>Public</p>
        </div>
        <div class="control-block-item" v-if="$auth.user.isSystem || $root.isAdmin">
          <i :class="[isVisible.icon]"></i>
          <p>Hidden</p>
        </div>
      </div>
    </page-header>

  <!-- Todo: replace with real stats
    <el-row :gutter="20" type="flex" justify="center" class="body-padding mobile-padding hide-mobile">
      <el-col :lg="12" :sm="24" class="status-container">
        <stat-card title="Total transactions" :stat="stats[1]" :transparent="true" />
        <stat-card title="Litres delivered" :stat="stats[2]" :transparent="true" />
        <stat-card title="Transactions this month" :stat="stats[0]" :transparent="true"/>
      </el-col>
    </el-row>
    -->

    <el-row :gutter="20" style="margin-bottom: 20px;" class="body-padding mobile-padding">
      <el-col :md="15" :lg="16">
        <el-card>
          <h1 class="title hide-mobile">Station specific transaction</h1>
          <transactions :api="$api.station($route.params.sId).transactions" />
        </el-card>
      </el-col>
      <el-col :md="9" :lg="8">
        <el-card class="no-padding">
          <station-details v-if="station.locationCoordinates !== null" :station="station" @edit="showUpsertStationDialog = true" />
        </el-card>
        <el-card v-if="station.organization && station.organization.id" style="margin-top: 20px;">
          <station-pricing :station="station" />
        </el-card>
        <el-card v-if="station.organization && station.organization.id" style="margin-top: 20px;">
          <station-certification :station="station" @refresh="getStation" />
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" :visible.sync="showStatusDialog" custom-class="dialog-no-padding dialog-invert full-width-mobile">
      <status :station="station"/>
    </el-dialog>

    <el-dialog :append-to-body="true" v-if="$auth.user.isSystem" :visible.sync="showUpsertStationDialog" :show-close="false" width="70%" top="1.5vh" custom-class="dialog-no-padding dialog-invert">
      <station-upsert-form
        :coordinates="station.locationCoordinates"
        @update="handleUpdate"
        :station="station"
        v-if="showUpsertStationDialog" />
      <!-- <el-row>
        <el-col :span="9">
        </el-col>
        <el-col :span="15">
          <station-map :stations="stations" :map-only="true" :showAvailabilityPopup="true"  height="700" :set="true" @setMarker="setCoordinates" v-if="showUpsertStationDialog"/>
        </el-col>
      </el-row> -->
    </el-dialog>

    <el-dialog :append-to-body="true" v-if="$root.isSystem" width="490px" top="5vh" custom-class="dialog-no-padding" :visible.sync="showQRDialog">
      <qr :station="station" />
    </el-dialog>

  </div>
</template>

<script>
import StationDetails from './StationDetails'
import StatCard from '@/components/shared/StatCard'
import Transactions from '@/components/dashboard/transactions/Transactions'
import StationMap from '@/components/dashboard/stations/map/StationMap'
import Status from './Status'
import StationUpsertForm from './../UpsertForm'
import qr from './../QR'
import StationPricing from './Pricing/StationPricing'
import StationCertification from './Certification/StationCertification'

export default {
  name: 'Station',
  components: { StationDetails, StatCard, Transactions, StationMap, Status, StationUpsertForm, qr, StationPricing, StationCertification },
  data () {
    return {
      showQRDialog: false,
      showUpsertStationDialog: false,
      showStatusDialog: false,
      loading: true,
      stations: [],
      station: {
        name: 'Loading...',
        locationCoordinates: null,
        tempCoordinates: null,
        organization: {
          country: {}
        }
      }
    }
  },
  watch: {
    'showUpsertStationDialog' (val) {
      if (val) {
        if (this.stations.length === 0) {
          this.stations.push(this.station)
        }
      } else {
        this.stations = []
      }
    }
  },
  computed: {
    stats () {
      if (this.$auth.user.isSystem || this.$root.isAdmin) {
        return [21, 324, 1912]
      }

      return [1, 23, 238]
    },
    getLocation () {
      return this.station.locationCoordinates.split(',')
    },
    isPublic () {
      return {
        icon: this.station.public ? 'el-icon-circle-check-outline' : 'el-icon-circle-close-outline'
      }
    },
    isVisible () {
      return {
        icon: this.station.hidden ? 'el-icon-circle-check-outline' : 'el-icon-circle-close-outline'
      }
    },
    getStatus () {
      let extraClass = ''
      if (!this.$auth.user.isSystem) {
        extraClass = 'no-effect'
      }

      if (this.inactive) {
        return {
          name: 'Inactive',
          icon: 'el-icon-close',
          class: 'inactive ' + extraClass
        }
      }

      if (this.maintenance) {
        return {
          name: 'Maintenance',
          icon: 'el-icon-refresh',
          class: 'maintenance ' + extraClass
        }
      }

      if (this.active) {
        return {
          name: 'Active',
          icon: 'el-icon-check',
          class: 'active ' + extraClass
        }
      }

      return ''
    },
    active () {
      return this.station.statusType === 0
    },
    maintenance () {
      return this.station.statusType === 1
    },
    inactive () {
      return this.station.statusType === 2
    },
    logoPath () {
      let obj = { backgroundImage: '' }
      if (this.station.logo) {
        obj.backgroundImage = 'url(' + this.station.logo.absolutePath + ')'
        obj.backgroundColor = 'white'
      } else {
        obj.backgroundImage = 'url(http://divegas.eu/application/files/7714/2167/8894/DIVEGAS_LOGO_BLUE.png)'
      }
      return obj
    }
  },
  methods: {
    setStatus () {
      if (this.$auth.user.isSystem) {
        this.showStatusDialog = true
      }
    },
    setCoordinates (coor) {
      this.station.tempCoordinates = coor.lat + ',' + coor.lng
      this.stations.pop()
    },
    handleUpdate (station) {
      this.station = station
      this.showUpsertStationDialog = false
    },
    getStation () {
      this.$http.get(this.$api.station(this.$route.params.sId).get)
        .then(response => {
          this.station = response.data
          this.loading = false
          this.stations.push(this.station)
          this.$root.organizationId = this.station.organization.id
        }, _ => {
          this.$message.error('Station could not be loaded')
        })
    }
  },
  created () {
    this.getStation()
  }
}
</script>

<style lang="scss" scoped>

  .status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: 20px;
  }

  .status-button {
    cursor: pointer;
    transition: background-color .2s ease-out;

    @include breakpoint (xs) {
      border-color: white !important;
      
      p {
        color: white !important;
      }
    }

    &.no-effect {
      transition: none;
      background-color: transparent !important;
      cursor: default;
    }

    &.active {
      border-color: #53D788;
      color: #53D788;
    }

    &.maintenance {
      border-color: #F8C764;
      color: #F8C764;
    }

    &.inactive {
      border-color: #FD6F71;
      color: #FD6F71;
    }

    &:hover {
      background-color: #53D788;

      &:not(.no-effect) {
        color: white;

        p {
          color: white;
        }
      }

      &.active {
        background-color: #53D788;
      }

      &.maintenance {
        background-color: #F8C764;
      }

      &.inactive {
        background-color: #FD6F71;
      }
    }
  }

  .status-edit-button {
    position: absolute;
    left: 30px;
    top: 15px;
    z-index: 999;
  }

  .header-image {
    width: 100%;
    background-color: #008fcc;
    height: 150px;
    background-position: center center;
    background-size: 50% auto;
    background-repeat: no-repeat;
    margin-top: 0px;
    margin-bottom: 20px;

    -webkit-box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
    -moz-box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.01);
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Station.vue